export enum PlanTypeEnum {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}
